import React, { useState } from 'react';
import styled from 'styled-components';
import { useMutation } from '@apollo/client';
import { SecondaryButton } from '../../Button';
import { ANALYSIS_CUSTOMIZE } from '../../../utils/apollo/analysis';
import {
  IAnalysisCustomizeMutation,
  IAnalysisCustomizeMutationVariables,
} from '../../../utils/apollo/graphqlSchema';
import printGraphqlErrors from '../../../utils/apollo/printGraphqlErrors';
import { assertNotNil } from '../../../utils/types';
import useExecutedReport from '../../../utils/builder/useExecutedReport';

interface IProps {
  analysisId: string;
  label: string;
  disabled?: boolean;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;
`;

const Label = styled.div`
  font-weight: 500;
`;

const UnSampleButton = ({ analysisId, label, disabled = false }: IProps) => {
  const [isRunning, setIsRunning] = useState(false);

  const handleExecutedReport = useExecutedReport();

  const handleCompleteMutation = ({
    analysisCustomize,
  }: IAnalysisCustomizeMutation) => {
    const { errors, entity } = analysisCustomize;

    if (printGraphqlErrors(errors)) {
      setIsRunning(false);
      return;
    }

    assertNotNil(entity);

    handleExecutedReport(entity);
    setIsRunning(false);
  };

  const [customizeAnalysis] = useMutation<
    IAnalysisCustomizeMutation,
    IAnalysisCustomizeMutationVariables
  >(ANALYSIS_CUSTOMIZE, {
    onCompleted: handleCompleteMutation,
  });

  const handleClick = () => {
    setIsRunning(true);
    customizeAnalysis({
      variables: {
        input: {
          analysisId,
          samplePercentage: 100,
        },
      },
    });
  };

  return (
    <Container>
      <Label>{label}</Label>
      {!disabled && (
        <SecondaryButton
          type="button"
          onClick={handleClick}
          disabled={isRunning}
          isOutlined
          trackContext="cohorts"
          trackAction="unsample"
        >
          Unsample
        </SecondaryButton>
      )}
    </Container>
  );
};

export default UnSampleButton;
